<template>
    <div>
        <!--/* Spinner */-->
        <page-loading-spinner class="over-page-loading-spinner" :is-refresh-loading="isRefreshLoading" />

        <section id="offer-tiles" class="container-fluid pt-1">
            <div class="d-flex flex-row justify-content-between align-items-center my-lg-1">
                <div>
                    <h1 class="mb-0 pb-0" v-html="mobileOffersDto.title" />
                    <div v-if="mobileOffersDto.subTitle">
                        <p class="h4 mb-0" v-html="mobileOffersDto.subTitle" />
                    </div>
                </div>
                <div v-if="mobileOffersDto.digitalCartTooltipDto">
                    <div class="row justify-content-end">
                        <div class="col-auto">
                            <digital-cart-tooltip
                                :title="mobileOffersDto.digitalCartTooltipDto.title"
                                :content="mobileOffersDto.digitalCartTooltipDto.content"
                                :cta-label="mobileOffersDto.digitalCartTooltipDto.ctaLabel"
                                :cta-url="mobileOffersDto.digitalCartTooltipDto.cartPageUrl"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <ob1-separateur class="my-1" />
                    <div class="mb-1 mt-lg-2">
                        <switch-live-box-customer
                            v-if="mobileOffersDto.openCustomerDto || switchOpen || mobileOffersDto.discountAdvantagesDto"
                            id="offers-switches"
                            :switch-open="switchOpen"
                            :open-customer-dto="mobileOffersDto.openCustomerDto"
                            :discount-advantages-dto="mobileOffersDto.discountAdvantagesDto"
                            @switch="switchLiveBoxCustomerOffers($event)"
                        />
                    </div>
                </div>
            </div>

            <!--/* Page Menu */-->
            <div v-if="showSimSubSwitch" class="row d-flex justify-content-center mb-2">
                <div class="col-12 col-sm-10 col-md-6">
                    <ob1-page-menu
                        id="offers-page-menu"
                        :tabs="getTabs()"
                        :tms-category="'onglet_cremaillere'"
                        with-icons
                        class="sticky bg-white ob1-menu-page-fullscreen ob1-menu-page-icon ob1-menu-page-center"
                        style="width: 100% !important; height: auto !important;"
                        @ob1-page-menu-click="switchMenu"
                    />
                </div>
            </div>

            <!--/* Offres */-->
            <div
                v-if="selectedSegment"
                class="row mb-2"
            >
                <div
                    v-for="(offer, index) in displayOffersSegments"
                    :key="'offer-' + index"
                    class="col-12 col-md-6 col-lg-4 mb-1 tile-wrapper"
                >
                    <mobile-offer-card-cds
                        data-segment="segment-data"
                        :offer="offer"
                        :logo5g-src="mobileOffersDto.image5gCds"
                        section-id="segment-data"
                        :advantage-offer-mobile-message="advantageOfferMobileMessage(offer.idSeo)"
                        :is-sub="isSub"
                        :is-fmr="switchOpen ? switchOpen.switchDto.checked : withOpenPrices"
                        :is-black="offer.promoted"
                        @selected-offer-details="selectedOfferDetails"
                        @add-offer-in-cart="onAddOfferInCart"
                    />
                </div>
                <div class="col-12 text-center mt-1">
                    <ob1-boutons
                        v-if="showMoreOffersButton"
                        class="px-3"
                        :is-button="true"
                        :is-secondary="true"
                        :label="moreOffersButton + ' (' + (selectedSegment.offers.length - displayOffersSegments.length) + ')'"
                        data-oevent-category="liste_forfait"
                        :data-oevent-action="getLabelToTmsFormat(moreOffersButton)"
                        data-oevent-label="voir_plus"
                        @ob1-boutons-click.prevent="sliceMoreOffersSegments()"
                    />
                    <ob1-boutons
                        v-if="showLessOffersButton"
                        class="px-3"
                        :is-button="true"
                        :is-secondary="true"
                        :label="lessOffersButton"
                        data-oevent-category="liste_forfait"
                        :data-oevent-action="getLabelToTmsFormat(lessOffersButton)"
                        data-oevent-label="voir_moins"
                        @ob1-boutons-click.prevent="sliceLessOffersSegments()"
                    />
                </div>
            </div>
            <offers-detail-popin
                v-if="showSegmentsDetail"
                id="offer-details-popin"
                ref="offerDetailsPopin"
                :new-sub-seo-ids="mobileOffersDto.newSubSeoIds"
                :new-sub-message="mobileOffersDto.newSubMessage"
                :offers="selectedSegmentDetail.offers"
                :is-sub="isSub"
                :logo5g-src="mobileOffersDto.image5gCds"
                @change-offer-blocked="changeOfferBlocked"
                @add-offer-in-cart="onAddOfferInCart"
            />
        </section>

        <!--/* Sélection forfaits */-->
        <section v-if="selectionAnimation && selectionAnimation.selectionsTileList.length > 0" class="container-fluid pt-1 pt-md-2">
            <div class="row mb-1 mb-lg-2">
                <div class="col-12">
                    <h2>{{ selectionAnimation.title }}</h2>
                </div>
                <div v-for="(selectionTile, index) in selectionAnimation.selectionsTileList" :key="index" class="col-12 col-lg-6 pb-1 pb-lg-2">
                    <div class="bg-dark h-100">
                        <a
                            class="ob1-link no-decoration"
                            target="_blank"
                            :href="selectionTile.link"
                            :data-oevent-category="'zone_selection_forfait'"
                            :data-oevent-action="selectionTile.tmsName"
                            :data-oevent-label="selectionTile.link"
                        >
                            <div class="h-100 d-flex align-items-center">
                                <div class="p-0">
                                    <img
                                        :srcset="selectionTile.img.srcSet"
                                        :src="selectionTile.img.src"
                                        :alt="selectionTile.img.alt"
                                        class="img-avantages"
                                    >
                                </div>
                                <div class="p-1 text-white">
                                    <p class="lead fw-bold py-0 mb-0" v-html="selectionTile.desc" />
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <!--/* Avantages */-->
        <section class="content-visibility-auto bg-gray2">
            <brand-animation-section-cds
                v-if="brandAnimation"
                class="pt-2 container-fluid"
                :brand-animation="brandAnimation"
            />
        </section>

        <!--/* Animation 5G, FAQ, ... */-->
        <section class="container-fluid pt-2 content-visibility-auto">
            <info-5g-tile-cds
                v-if="showSegments && showInfoAlert5G"
                :is-sosh="false"
                :is-wide="false"
                :title="selectedSegment.infoAlert5G.title"
                :image="mobileOffersDto.image5gCds"
                :list="selectedSegment.infoAlert5G.list"
                :link="selectedSegment.infoAlert5G.link"
                :class="'px-1'"
            />
            <faq :title="mobileOffersDto.faq.title" :question-list="mobileOffersDto.faq.questionList" />
        </section>

        <ob1-snack-bar
            id="cartPageSnackbar"
            ref="cartPageSnackbar"
            class="over-page-loading-spinner"
            :icon="snackbarIcon"
            :label="snackbarMessage"
        />
    </div>
</template>

<script>
import Faq from "../../../common/fragments/Faq.vue";
import SwitchLiveBoxCustomer from "../fragments/SwitchLiveBoxCustomer.vue";
import MobileOfferCardCds from "../fragments/MobileOfferCardCds.vue";
import OffersDetailPopin from "../fragments/OffersDetailPopin.vue";
import Info5gTileCds from "../../../common/Info5gTileCds.vue";
import BrandAnimationSectionCds from "../../../common/fragments/BrandAnimationSectionCds.vue";
import DigitalCartTooltip from "../../../../common/components/vue/tooltip/DigitalCartTooltip.vue";
import PageLoadingSpinner from "../../../../common/components/vue/PageLoadingSpinner.vue";

const mobileOffersDto = JSON.parse(document.getElementById('mobile-offers-cds').dataset.mobileOffersDto);
export default {
    name: "OffersCds",
    components: {
      PageLoadingSpinner,
        DigitalCartTooltip,
        BrandAnimationSectionCds,
        Info5gTileCds,
        OffersDetailPopin,
        MobileOfferCardCds,
        SwitchLiveBoxCustomer,
        Faq
    },
    data() {
        return {
            mobileOffersDto: mobileOffersDto,
            selectedSegment: null, // segment contenant les offres filtrées(sans engagement et avec engagement)
            selectedSegmentDetail: null, // segment contenant toutes les offres pour la popin
            brandAnimation: mobileOffersDto.brandAnimationCds,
            selectionAnimation: mobileOffersDto.selectionTileDto,
            withOpenPrices: mobileOffersDto.withOpenPrices,
            switchOpen: mobileOffersDto.switch,
            isSub: false,
            offset: 0,
            blocked: true,
            displayOffersSegments: [],
            moreOffersButton: "",
            lessOffersButton: "",
            selectedOfferIdSeo: "",
            hashTagForfait: "forfait",
            hashTagForfaitPlusMobile: "forfait-plus-mobile",
            snackbarMessage: "",
            snackbarIcon: "icon-error-severe",
            isRefreshLoading: false,
        }
    },
    computed: {
        showInfoAlert5G() {
            return this.selectedSegment.infoAlert5G !== null
        },
        showSegments() {
            return this.selectedSegment && this.selectedSegment.offers.length > 0
        },
        showSegmentsDetail() {
            return this.selectedSegmentDetail && this.selectedSegmentDetail.offers.length > 0
        },
        showMoreOffersButton() {
            if (this.selectedSegment === null) {
                return false
            }
            if (this.selectedSegment.offers.length <= 3) {
                return false
            }
            return this.displayOffersSegments.length < this.selectedSegment.offers.length
        },
        showLessOffersButton() {
            if (this.selectedSegment === null) {
                return false
            }
            if (this.selectedSegment.offers.length <= 3) {
                return false
            }
            return this.displayOffersSegments.length >= this.selectedSegment.offers.length
        },
        openPacks() {
            const zigZagItemsUpdate = {...this.mobileOffersDto.openPacks}.zigZagItems.map(zigZagItem => {
                let imageUpdate = {...zigZagItem.image, xxlSrcSet: zigZagItem.image.xlSrcSet}
                return {...zigZagItem, image: imageUpdate}
            })
            return {...this.mobileOffersDto.openPacks, zigZagItems: zigZagItemsUpdate}
        },
        showSimSubSwitch() {
          const offers = this.mobileOffersDto.offerSegments.flatMap(segment => segment.offers);
          const hasSub = offers.some(offer => offer.sub);
          const hasSim = offers.some(offer => !offer.sub);

          return hasSub && hasSim;
        },
    },
    mounted() {
        this.removeSkeleton()
        this.initUrl()
        this.isSub = window.location.hash === "#" + this.hashTagForfaitPlusMobile
        this.filterSubOffers(this.isSub, this.withOpenPrices, false,false, false)
        if (this.selectedSegment) {
            window.addEventListener("resize", () => {
                this.alignElements();
            });
        }
    },
    updated() {
        this.$nextTick(function () {
            this.alignElements();
        })
    },
    methods: {
        advantageOfferMobileMessage(offerIdSeo) {
            if (this.mobileOffersDto.advantageOfferMobileSeoIds.includes(offerIdSeo)) {
                return this.mobileOffersDto.advantageOfferMobileMessage;
            }
            return null;
        },
        removeSkeleton() {
            document.getElementById("skeleton-mobile-offers").remove()
        },
        initUrl() {
            if (this.switchOpen) {
                if (!window.location.href.includes('internet')) {
                    // ajoute le paramètre internet en fonction de l'éligibilité fmr du client
                    const withOpenPricesString = this.withOpenPrices ? "true" : "false";
                    const newUrl = addParam(window.location.href, "internet=" + withOpenPricesString);
                    window.history.replaceState({}, null, newUrl);
                }
            }
        },
        switchLiveBoxCustomerOffers(event) {
            this.updateOpenSwitchList(event.checked)
            this.filterSubOffers(this.isSub, event.checked, true, false, false);
        },
        switchMenu(id) {
            this.isSub = id === this.hashTagForfaitPlusMobile
            this.filterSubOffers(this.isSub, this.switchOpen ? this.switchOpen.switchDto.checked : this.mobileOffersDto.withOpenPrices, false, true, false)
        },
        updateOpenSwitchList(checked) {
            if (this.switchOpen) {
                this.switchOpen.switchDto.checked = checked
            }
        },
        filterSubOffers(sub, fmr, fromSwitchFmr, fromSwitchMenu, fromSwitchBlocked) {
            this.updateFilteredSubOffers(sub, fmr);
            if (fromSwitchBlocked || fromSwitchFmr) {
                //On garde l'offset pour les forfaits bloqués non bloqués
                this.displayOffersSegments = this.selectedSegment.offers.slice(0, this.offset);
            } else {
                this.offset = 0;
                this.sliceMoreOffersSegments();
            }
            this.moreOffersButton = this.isSub ? this.mobileOffersDto.moreSubOffersButtonLabel : this.mobileOffersDto.moreOffersButtonLabel
            this.lessOffersButton = this.isSub ? this.mobileOffersDto.lessSubOffersButtonLabel : this.mobileOffersDto.lessOffersButtonLabel
            this.updateUrl(fmr);
            this.updateHashUrl(fromSwitchMenu);
        },
        sliceMoreOffersSegments() {
            if (this.offset < this.selectedSegment.offers.length) {
                this.offset += 3;
            }
            this.displayOffersSegments = this.selectedSegment.offers.slice(0, this.offset);
            return this.displayOffersSegments;
        },
        sliceLessOffersSegments() {
            if (this.offset < 0) {
                return
            }
            this.displayOffersSegments = this.selectedSegment.offers.slice(0, this.offset - 3);
            this.offset -= 3;
            return this.displayOffersSegments;
        },
        updateFilteredSubOffers(sub, fmr) {
          let segment = null;
          const offerSegments = JSON.parse(JSON.stringify(mobileOffersDto.offerSegments));

          offerSegments.forEach(offerSegment => {
            const filteredOffers = offerSegment.offers.filter(offer => offer.sub === sub && offer.fmr === fmr);
            if (filteredOffers.length > 0) {
              const has5GOffer = filteredOffers.some(offer => offer.is5G);
              segment = {
                ...offerSegment,
                offers: filteredOffers,
                infoAlert5G: has5GOffer ? offerSegment.infoAlert5G : null
              };
            }
          });

          if (!segment) {
            segment = { offers: [], infoAlert5G: null };
          }

          this.selectedSegmentDetail = { ...segment };

          const filteredSegmentOffers = segment.offers.filter(offer => offer.blocked === undefined || offer.blocked === this.blocked);
          this.selectedSegment = { ...segment, offers: filteredSegmentOffers };
        },
        updateUrl(fmr) {
            const newUrl = new URL(window.location.href);
            this.switchOpen ? newUrl.searchParams.set("internet", fmr) : newUrl.searchParams.delete("internet");
            window.history.replaceState({}, null, newUrl.toString());
        },
        updateHashUrl(fromSwitchMenu) {
            const newUrl = new URL(window.location.href);
            const hash = window.location.hash;
            if (hash === "#" + this.hashTagForfait) {
                newUrl.hash = fromSwitchMenu ? "#" + this.hashTagForfaitPlusMobile : "#" + this.hashTagForfait;
            } else if (hash === "#" + this.hashTagForfaitPlusMobile) {
                newUrl.hash = fromSwitchMenu ? "#" + this.hashTagForfait : "#" + this.hashTagForfaitPlusMobile;
            } else {
                newUrl.hash = ""
                newUrl.href = this.isSub ? newUrl.href + "#" + this.hashTagForfaitPlusMobile : newUrl.href + "#" + this.hashTagForfait;
            }
            window.history.replaceState({}, null, newUrl.toString());
        },
        openAnimationPage(animation) {
            Tms.link({
                category: stripAccents(animation.title).split(' ').join('_'),
                action: stripAccents(animation.urlAccessWording).split(' ').join('_'),
                label: animation.url
            });
            window.location.href = animation.url
        },
        openSegmentAnimationPage(url, urlAccessWording) {
            Tms.link({
                category: stripAccents("mes_avantages_cremailliere"),
                action: stripAccents(urlAccessWording).split(' ').join('_'),
                label: url
            });
        },
        alignElementsHeights(...elementSelectors) {
            elementSelectors.forEach((elementSelector) => {
                const elementsToAlign = Array.from(document.querySelectorAll(elementSelector));
                elementsToAlign.forEach((element) => element.style.removeProperty("height"));
                if (window.innerWidth >= myshop.ob1.breakpoints.md) {
                    const heightData = elementsToAlign.reduce(function (accumulator, element) {
                        const jqElement = $(element);
                        return {
                            jqElements: accumulator.jqElements.concat(jqElement),
                            max: Math.max(accumulator.max, jqElement.height())
                        };
                    }, {jqElements: [], max: 0});
                    heightData.jqElements.forEach((jqElement) => jqElement.height(heightData.max));
                }
            })
        },
        alignElements() {
            const segments = Array.from(document.querySelectorAll("[data-segment]"));
            segments.forEach((segment) => {
                const segmentId = segment.dataset.segment

                const titleSelector = this.getSelector("title-wrapper", segmentId);
                const advantageSelector = this.getSelector("advantage-message-wrapper", segmentId);
                const priceSelector = this.getSelector("price-wrapper", segmentId);
                const claimSelector = this.getSelector("claim-wrapper", segmentId);
                const messageSelector = this.getSelector("message-wrapper", segmentId);

                this.alignElementsHeights(titleSelector, advantageSelector, priceSelector, claimSelector, messageSelector)

            });

        },
        getSelector(itemClass, segmentId) {
            return "[data-segment='" + segmentId + "']" + " ." + itemClass;
        },
        selectedOfferDetails(offer) {
            this.$refs.offerDetailsPopin.radioButtonOfferSelected = offer;
        },
        changeOfferBlocked(blocked) {
            this.blocked = blocked
            this.$nextTick(() => {
                this.filterSubOffers(this.isSub, this.switchOpen ? this.switchOpen.switchDto.checked : this.mobileOffersDto.withOpenPrices, false,false, true)
            });
        },
        getTabs(){
            return [
                {
                    id: this.hashTagForfait,
                    label: this.mobileOffersDto.menuTabForfaitTitle,
                    tmsName: this.mobileOffersDto.menuTabForfaitTitleTmsName,
                    isActive: !this.isSub,
                    icon: "icon-sim",
                },
                {
                    id: this.hashTagForfaitPlusMobile,
                    label: this.mobileOffersDto.menuTabForfaitPlusMobileTitle,
                    tmsName: this.mobileOffersDto.menuTabForfaitPlusMobileTitleTmsName,
                    isActive: this.isSub,
                    icon: "icon-tel-sim"
                },
            ]
        },
        getLabelToTmsFormat(label) {
            return stripAccents(label).split(' ').join('_');
        },
        onAddOfferInCart(idSeo) {
          this.isRefreshLoading = true;
          const actionUrl = this.mobileOffersDto.cartApiUrl;
          const actionJsonFormParams = {id: idSeo, deviceEan: undefined, universe: "MOBILE"};

          const addMobileOfferSuccessHandler = (event) => {
            this.displayMessageAndRefresh(event);
            const redirectUrl = this.mobileOffersDto.digitalCartTooltipDto?.cartPageUrl;
            if (redirectUrl) {
              window.location.href = redirectUrl
            }
          };

          const addMobileOfferFailHandler = (error) => {
            const snackBarAlert = error.responseJSON && error.responseJSON.snackBarAlert
                ? error.responseJSON.snackBarAlert : {
                  message: "Une erreur est survenue lors de l'ajout de l'offre dans votre panier",
                  icon: "icon-error-severe"
                };
            const event = {snackBarAlert};
            this.displayMessageAndRefresh(event);
          };

          $.ajax({
            method: "POST",
            url: actionUrl,
            contentType: "application/json",
            data: JSON.stringify(actionJsonFormParams)
          })
              .done(addMobileOfferSuccessHandler)
              .fail(addMobileOfferFailHandler)
              .always(() => {
                this.isRefreshLoading = false;
              });

          return false;
        },

        displayMessageAndRefresh: function (event) {
          if (event && event.snackBarAlert) {
            this.displaySnackBarAlertMessage(event.snackBarAlert);
          }
        },

        displaySnackBarAlertMessage: function (snackBarAlert) {
          if (snackBarAlert) {
            this.snackbarMessage = snackBarAlert.message;
            this.snackbarIcon = snackBarAlert.icon;
            const snackbar = this.$refs.cartPageSnackbar;
            if (snackbar) {
              snackbar.show();
            }
          }
        }
      }
}
</script>

<style lang="scss">
.sticky {
    position: sticky;
    top: 0;
    z-index: 3;
}

.ob1-menu-page .ob1-nav-light > .nav-item:not(:first-child) > .nav-link {
    margin-left: 60px;
}

.img-avantages {
    height: 105px;
    @media (min-width: 768px) {
        height: 130px;
    }
}

.over-page-loading-spinner {
  z-index: 10000;
}
</style>
